export default __webpack_public_path__ + "static/media/轮播首图11.6aae92c7.jpg";